module.exports = __webpack_public_path__ + "img/background051.211c5e21.jpg";